module.exports = __webpack_public_path__ + "img/1.3aabf184.jpg";